import { render, staticRenderFns } from "./Rekening.vue?vue&type=template&id=5227ed7c"
import script from "./Rekening.vue?vue&type=script&lang=js"
export * from "./Rekening.vue?vue&type=script&lang=js"
import style0 from "./Rekening.vue?vue&type=style&index=0&id=5227ed7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports